import { find, map, groupBy, kebabCase, uniq } from 'lodash'

export default {
  props: {
    country_id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      country: {}
    }
  },
  mounted () {
    this.findCountry()
  },
  computed: {
    listCountries() {

      let players = map(this.country.players, p => {
        p.url = kebabCase(p.short_name)
        return p
      })

      return map(groupBy(players, 'country_iso_3'), (item, iso) => {
        return {
          value: iso,
          country_iso3: iso,
          text: `${uniq(map(item, 'country')).join("")} (${item.length})`,
          country: uniq(map(item, 'country')).join(""),
          players: item
        }
      })
    }
  },
  watch: {
    country_id () {
      this.findCountry()
    }
  },
  methods: {
    kebabCase,
    findCountry() {
      let country = find(this.$store.state.players.countries, ['country_url', this.country_id])
      this.$set(this, 'country', country)
    }
  }
}
